/* @flow */
import * as React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import { Box, Text, Stack, Columns, Column } from '@locus-taxy/neo-ui';
import NumberUtils from 'common/utils/NumberUtils';
import { type ThemeType } from 'react-css-themr';
import { type TFunction } from 'react-i18next';
import type { TerritoryZoneType } from './TerritoryPolygon';

export type PolygonTypeType = 'NORMAL' | 'CONVEX_HULL';
type Props = {
    zone: TerritoryZoneType,
    key: string,
    id: string,
    index: number,
    key: string,
    theme: ThemeType,
    t: TFunction
};
type State = {
    hovered: boolean
};
class TerritoryPolygon extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hovered: false
        };
    }
    render() {
        const { zone, theme, t } = this.props;
        const { stats } = zone;
        return (
            <Polygon
                zone={zone}
                key={zone.zone}
                id={zone.zone}
                color={zone.color}
                positions={zone.polygon}
            >
                <Tooltip className={theme.labelWrap} direction="auto" sticky>
                    <Box
                        p={2}
                        backgroundColor="white"
                        height="auto"
                        width="400px"
                    >
                        <Stack space="small">
                            <Columns>
                                <Column width="fluid">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {t('territory.numberOfStores')}
                                    </Text>
                                </Column>
                                <Column width="content">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {stats.totalOutlets}
                                    </Text>
                                </Column>
                            </Columns>
                            <Columns>
                                <Column width="fluid">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {t('territory.totalRevenue')}
                                    </Text>
                                </Column>
                                <Column width="content">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {stats.totalRevenue}
                                    </Text>
                                </Column>
                            </Columns>
                            <Columns>
                                <Column width="fluid">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {t('territory.avgRevenuePerStore')}
                                    </Text>
                                </Column>
                                <Column width="content">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {NumberUtils.formatNumber(
                                            stats.avgRevenue,
                                            true,
                                            2
                                        )}
                                    </Text>
                                </Column>
                            </Columns>
                            <Columns>
                                <Column width="fluid">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {t('territory.totalTransactionTime')}
                                    </Text>
                                </Column>
                                <Column width="content">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {stats.tat}
                                    </Text>
                                </Column>
                            </Columns>
                            <Columns>
                                <Column width="fluid">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {t('territory.totalTravelTime')}
                                    </Text>
                                </Column>
                                <Column width="content">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        -
                                    </Text>
                                </Column>
                            </Columns>
                            <Columns>
                                <Column width="fluid">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        {t('territory.totalDistanceTravelled')}
                                    </Text>
                                </Column>
                                <Column width="content">
                                    <Text
                                        textTransform="uppercase"
                                        fontSize={1}
                                        fontWeight="600"
                                    >
                                        -
                                    </Text>
                                </Column>
                            </Columns>
                        </Stack>
                    </Box>
                </Tooltip>
            </Polygon>
        );
    }
}

export default TerritoryPolygon;
